import { render, staticRenderFns } from "./Marketegg.vue?vue&type=template&id=4f45dc04&scoped=true"
import script from "./Marketegg.vue?vue&type=script&lang=js"
export * from "./Marketegg.vue?vue&type=script&lang=js"
import style0 from "./Marketegg.vue?vue&type=style&index=0&id=4f45dc04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45dc04",
  null
  
)

export default component.exports